// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"13dfbe7b","780":"95f31ad1"}[chunkId] + ".chunk.css";
};